import { getStoredUser } from "@/utils/auth";
import type {
  ESignatureCeremonyPayload,
  ESignatureMethod,
} from "@/types/eSignature.type";

export function buildAttestationCeremony(params: {
  signerRole: string;
  signatureMeaning: string;
  signatureMethod?: ESignatureMethod;
}): ESignatureCeremonyPayload {
  const user = getStoredUser();
  const fullName = user
    ? `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim()
    : "";

  return {
    signerName: fullName !== "" ? fullName : user?.username,
    signerRole: params.signerRole,
    signerConsumerId: user?.id,
    signatureMethod: params.signatureMethod ?? "attestation",
    signatureMeaning: params.signatureMeaning,
  };
}

/** @deprecated Use buildAttestationCeremony — client must not send signedAt/ip. */
export function buildAttestationESignature(params: {
  signerRole: string;
  signatureMeaning: string;
  signatureMethod?: ESignatureMethod;
}): ESignatureCeremonyPayload {
  return buildAttestationCeremony(params);
}

export function assertESignatureCeremonyPayload(
  payload: ESignatureCeremonyPayload | undefined,
  context: string,
): asserts payload is ESignatureCeremonyPayload {
  if (!payload) {
    throw new Error(`Electronic signature is required for ${context}`);
  }
  if (!payload.signerRole?.trim()) {
    throw new Error("Signer role is required");
  }
  if (!payload.signatureMeaning?.trim()) {
    throw new Error("Signature meaning is required");
  }
  if (!payload.signatureMethod?.trim()) {
    throw new Error("Signature method is required");
  }
}

export function resolveUserRoleLabel(
  userRole?: string,
  fallback = "Not available",
): string {
  if (userRole?.trim()) {
    return userRole.trim();
  }
  const user = getStoredUser();
  const role = user?.roles?.[0]?.role;
  return role?.trim() ?? fallback;
}
